jQuery.noConflict();

(function($, window) {
    var adjustAnchor = function() {

        var $anchor = $(':target'),
            fixedElementHeight = 150;

        if ($anchor.length > 0) {

            $('html, body')
                .stop() 
                .animate({
                    scrollTop: $anchor.offset().top - fixedElementHeight
                }, 200); 

        }

    };

    $(window).on('hashchange load', function(e) {
        e.preventDefault();
        adjustAnchor();
    });

})(jQuery, window);

(function($) {

    $(document).ready(function(){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a").fancybox();


        $('#search-trigger').keydown(function(event){ 
            var id = event.key || event.which || event.keyCode || 0;   
            if (id == 13) {
                $('#search-trigger').trigger('click');
            }
        });

        //Outline tab

        function keyboardFocus (e) {
            if (e.keyCode === 9) { // Tab key
              document.documentElement.classList.add('keyboard-focus');
            }
          
            document.removeEventListener('keydown', keyboardFocus, false);
          }
          
        document.documentElement.classList.remove('no-js');
        document.addEventListener('keydown', keyboardFocus, false);



        (function () {
            const $specialNotice = $('.special-notice-outer');

            $('.special-notice-outer .close').on('click', function (e) {
                e.preventDefault();
                $specialNotice.hide();
                $('.special-notice-active').removeClass('special-notice-active');

                setCookie('hideCovidNotice', true);
            });
        })();


        const clipBoardHandler = function () {
            $('[data-toggle="tooltip"]').tooltip({
                'trigger': 'manual',
                'container':  '#vlogeObrazciContent'
            });

            $(document).on("click",".copy-btn",function(e){
                e.preventDefault();
            });

            let clipboard = new ClipboardJS('.copy-btn');
            let $target;
            clipboard.on('success', function(e) {
                $target = $(e.trigger);
                $target.tooltip('show');

                setTimeout(function () {
                    $target.tooltip('hide');
                }, 1500);

                e.clearSelection();
            });
        };
        clipBoardHandler();

        (function () {
            $('#seja-select').on('change', function () {
                let v = $(this).val();

                $('.seja-loop-item').each(function () {
                    let id = $(this).attr('id');

                    if (v != id && v != '') {
                        $('#' + id).hide();
                    } else {
                        $('#' + id).show();
                    }

                });
            });
        })();

        function urlToPromise(url) {
            return new Promise(function(resolve, reject) {
                JSZipUtils.getBinaryContent(url, function (err, data) {
                    if(err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        $('#master-toggle').on('click', function (e) {
            e.preventDefault();

            let $that = $(this),
                $target = $($that.data('target')),
                $collapse = $target.find('.collapse');

            $that.toggleClass('active');

            if ($that.hasClass('active')) {
                $collapse.collapse('show');
            } else {
                $collapse.collapse('hide');
            }
        });




        $('#master-download').on('click', function (e) {
            e.preventDefault();

            let $that = $(this),
                $target = $($that.data('target')),
                zip = new JSZip(),
                $label = $(this).find('span'),
                tempLabel = $label.html(),
                zipFilename = $that.data('zipname');

            $that.addClass('disabled');
            $label.html(localize.translations.preparingFile);

            let $item,
                parentDirName,
                files,
                url,
                $group,
                groupName;

            $target.find('.card').each((k, v) => {
                $item = $(v);
                parentDirName = $item.find('h5').text();

                $item.find('.group:not(.other)').each((f, g) => {
                    $group = $(g);
                    groupName = $group.find('.group-name').html();
                    files = $group.find('.filename');

                    if (files.length > 0) {
                        files.each((n, f) => {
                            url = decodeURIComponent($(f).attr('href'));
                            zip.file(parentDirName + '/' + groupName + '/' + getFileName(url), urlToPromise(url), {binary:true});
                        });
                    }
                });

                $item.find('.group.other').each((f, g) => {
                    $group = $(g);
                    files = $group.find('.filename');

                    if (files.length > 0) {
                        files.each((n, f) => {
                            url = decodeURIComponent($(f).attr('href'));
                            zip.file(parentDirName + '/' + getFileName(url), urlToPromise(url), {binary:true});
                        });
                    }
                });
            });

            zip.generateAsync({type:"blob"})
                .then(function callback(blob) {

                    // see FileSaver.js
                    saveAs(blob, zipFilename);
                    $label.html(tempLabel);
                    $that.removeClass('disabled');
                });
        });


        function getSearchParameters() {
            var prmstr = window.location.search.substr(1);
            return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
        }

        function transformToAssocArray( prmstr ) {
            var params = {};
            var prmarr = prmstr.split("&");
            for ( var i = 0; i < prmarr.length; i++) {
                var tmparr = prmarr[i].split("=");
                params[tmparr[0]] = tmparr[1];
            }
            return params;
        }

        function setupAccordionControls(key) {
            if (!key) return false;

            let $targetItem, id, hash;

            hash = location.hash;

            if (hash !== undefined && hash !== '') {
                $targetItem = $(hash + ' .' + key);
            } else {
                $targetItem = $('.' + key);
            }

            id = $targetItem.attr('data-target');

            $(id).collapse('show');



            //Gotta wait for the tab to switch
            setTimeout(function(){

                $([document.documentElement, document.body]).animate({
                    scrollTop: $targetItem.offset().top - 200
                }, 500);

            }, 500);
        }



        (function () {
            let searchParams = getSearchParameters();

            if (!$.isEmptyObject(searchParams)) {
                if (searchParams.be !== undefined) {
                    setupAccordionControls(searchParams.be);
                } else if(searchParams.ia !== undefined) {
                    setupAccordionControls(searchParams.ia);
                }
            }
        })();


        (function () {
            let targetId = '',
                $statusFileWrapper = $('.status-filer-wrapper'),
                $navbar = $('#wrapper-navbar');

            /*$('#vloge-obrazci-predpisi-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                targetId = $(e.target).attr('id');



                $('html, body').animate({scrollTop:$(e.target).offset().top -  $navbar.height()}, 'fast');

                if (targetId === 'predpisi-tab') {
                    $statusFileWrapper.show();
                } else {
                    $statusFileWrapper.hide();
                }
            });*/



            $('#vloge-obrazci-predpisi-tabs').on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                targetId = $(e.currentTarget).attr('id');

                //console.log(e);

                $('html, body').animate({scrollTop:$(e.currentTarget).offset().top - $navbar.height() - 100}, 'fast');

                if (targetId === 'predpisi-tab') {
                    $statusFileWrapper.show();
                } else {
                    $statusFileWrapper.hide();
                }
            });
        })();


        (function () {
            let $form = $('#vop-controls');

            $form.on('submit', function (e) {
                e.preventDefault();
                let $that = $(this),
                    data = $that.serialize(),
                    $vlogeContainer = $('#vloge-obrazci'),
                    $predpisiContainer = $('#predpisi'),
                    $inputs = $that.find('input, select'),
                    $loader = $that.find('.loading-wrapper');

                $inputs.prop("disabled", true);
                $loader.show();

                ajaxHelper(data, 'vop_filter').then((response) => {
                    // $dlCounter.html(response.downloads);
                    // console.log('success');
                    // console.log(response);
                    $vlogeContainer.html(response.vloge);
                    $predpisiContainer.html(response.predpisi);
                    $inputs.prop("disabled", false);
                    $loader.hide();
                    clipBoardHandler();
                }, (response) => {
                    console.log(response);
                });
            });
        })();



        $(".owl-carousel").owlCarousel(
            {
                loop:false,
                nav:false,
                center:true,
                items: 1,
                dots: true,
                mouseDrag: false,
                autoplay: false,
                dotsContainer: $('.custom-dots'),
                navContainer: $('.custom-nav'),
                navText: [localize.translations.previous, localize.translations.next]
            }
        );


        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });


        (function () {
            let $navbar = $('#wrapper-navbar');

            $(document).on('scroll ready', function() {
                let scroll = $(window).scrollTop();

                if (scroll >= 100 ) {
                    $navbar.addClass('sticky');
                } else {
                    $navbar.removeClass('sticky');
                }
            });

        })();


        function scrollTo($element, offset = 300) {
            if (!$element) throw 'expects element to be jquery object';

            return new Promise((resolve) => {
                $('html, body').animate({
                    scrollTop: $element.offset().top - offset
                }, 300, function () {
                    resolve($element);
                });
            });

        }



        (function () {
            var $searchForm = $('#sp-search-form'),
                $input = $searchForm.find('#search-forms-applications'),
                $inputWrapper = $input.closest('.input-wrapper'),
                $overlay = $('.overlay'),
                $body = $('body'),
                $write = $searchForm.find('.write');



                
            initFileSearch($input);

            $input.on('keyup', function () {
                if (this.value.length < 4) {
                    $write.removeClass('d-none');
                } else {
                    $write.addClass('d-none');
                    $inputWrapper.removeClass('loading');
                }
            });


            $input.on('click', function () {

                if (!$searchForm.hasClass('expanded')) {
                    $body.addClass('file-search-active');

                    if ($searchForm.hasClass('special-notice-active')) {
                        scrollTo($searchForm, 300)
                            .then(function ($element) {
                                expand($element);
                                return $element;
                            });
                    } else {
                        scrollTo($searchForm, (isMobile) ? 50 : 300)
                            .then(function ($element) {
                                expand($element);
                                return $element;
                            });
                    }

                    $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                }

            });


            function expand(el) {
                el.addClass('expanded');
                return el;
            }

            function shrink(el) {
                el.removeClass('expanded');
                return el;
            }

            $overlay.on('click', closeFileSearch);

            //Close file search on esc
            $(document).keyup(function(e) {
                if (e.keyCode === 27) {
                    closeFileSearch();
                    $body.removeClass('overlay-active').removeClass('prevent-scroll');
                }
            });

            function closeFileSearch() {
                $body.removeClass('file-search-active');
                shrink($('#sp-search-form'));
                $input.autocomplete('val', '').autocomplete('close');
                $write.removeClass('active');
                $inputWrapper.removeClass('loading');
            }


            $(document).on('click', '.download-all', function (e) {
                e.preventDefault();

                let zip = new JSZip(),
                    zipFilename = $(this).attr('data-zipname');

                let files =  JSON.parse($(this).attr('data-files'));

                for (let i = 0; i < files.length; i++) {
                    files[i] =  decodeURIComponent(files[i]);
                }

                let count = 0;

                files.forEach(function(url){
                    let filename = getFileName(url);

                    // loading a file and add it in a zip file
                    JSZipUtils.getBinaryContent(url, function (err, data) {
                        if(err) {
                            throw err; // or handle the error
                        }
                        zip.file(filename, data, {binary:true});

                        count++;
                        if (count === files.length) {
                            zip.generateAsync({type:'blob'}).then(function(content) {
                                saveAs(content, zipFilename);
                            });
                        }
                    });
                });

            });

        })();



        function getFileName(url) {

            url = url.substring(0, (url.indexOf("#") == -1) ? url.length : url.indexOf("#"));

            url = url.substring(0, (url.indexOf("?") == -1) ? url.length : url.indexOf("?"));

            url = url.substring(url.lastIndexOf("/") + 1, url.length);

            return url;
        }

        (function () {
            let mainSearch = $('#search-query-input'),
                $searchForm = $('#searchform');

            if (mainSearch.length > 0) {
                initSearch(mainSearch);

                let $waitingInput = $searchForm.find('.search-waiting-input');

                mainSearch.on('keyup', function () {
                    if (this.value.length >= 4) {
                        $waitingInput.hide();
                    } else {
                        $waitingInput.show();
                    }
                });
            }
        })();

        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }



        function initFileSearch($element) {
            let cache = [];


            $('#sp-search-form').on('submit', function (e) {
                e.preventDefault();
            });


            function fileSearch(query, callback) {

                var $parent = $element.closest('.input-wrapper');

                $parent.addClass('loading');

                /** No => search for it */
                $.ajax({
                    'method': 'post',
                    'url': localize.ajaxurl,
                    'data': {
                        q: query,
                        action: 'emigma_ajax_search',
                        post_type: 'files'
                    },
                    'success': function (payload) {
                        $parent.removeClass('loading');
                        callback(JSON.parse(payload));
                    }
                });
            }

            $element.autocomplete({
                // keyboardShortcuts: ['s'],
                minLength: 4,
                appendTo: '#fileResultsWrapper',
                hint: false,
                debug: true,
            }, [
                {
                    source: fileSearch,
                    debounce: 300,
                    displayKey: false,


                    templates: {
                        suggestion: function(suggestion) {
                            // var query = $('#search-forms-applications').autocomplete('val');
                            //  var   regExp = new RegExp('(' + query + ')', 'giu');

                            // return '<div class="suggestion-item application">' +
                            //     '<div class="suggestion-title">' +
                            //         suggestion.name.replace(regExp, '<span class="highlight">$1</span>')
                            //     + '</div>' +
                            //
                            //     + '</div>';


                            return suggestion.markup;
                        },
                        empty: function() {
                            return '<div class="suggestion-item"><span>'+localize.translations.noResults+'<span></div>';
                        }
                    }
                }
            ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
                return false;
            });
        }


        function initSearch($element) {
            let cache = [];

            let $loader = $('.loading');

            function search(query, callback) {
                $loader.removeClass('d-none');

                /** No => search for it */
                $.ajax({
                    'method': 'post',
                    'url': localize.ajaxurl,
                    'data': {
                        q: query,
                        action: 'emigma_ajax_search'
                    },
                    'success': function (payload) {
                        callback(JSON.parse(payload));
                        $loader.addClass('d-none');
                    }
                });
            }

            window.emiSearch = $element.autocomplete({
                autoselect: false, // Select 1st item × search on enter UX
                autoselectOnBlur: false, // On mobile devices = true @todo
                openOnFocus: true,
                // keyboardShortcuts: ['s'],
                minLength: 4,
                debug: true
            }, [
                {
                    source: search,
                    debounce: 300,
                    displayKey: function(suggestion) {
                        return suggestion.name
                    },
                    templates: {
                        suggestion: function(suggestion) {
                            var query = $('#search-query-input').autocomplete('val');
                            console.log(query);
                            var regExp = new RegExp('(' + query + ')', 'giu');
                            var excerpt = suggestion.excerpt ? JSON.parse(suggestion.excerpt) : false;
                            var excerptOutput = excerpt ?                                 '<div class="suggestion-excerpt">' +
                                excerpt.replace(regExp, '<span class="highlight">$1</span>')
                                + '</div>' : '';
                            return '<div class="suggestion-item">' +
                                '<div class="suggestion-cpt">' + suggestion.cpt + '</div>' +
                                '<div class="suggestion-title">' +
                                suggestion.name.replace(regExp, '<span class="highlight">$1</span>')
                                + '</div>' +
                                excerptOutput
                                + '</div>';
                        },
                        empty: function() {
                            return '<div class="suggestion-item"><span>'+localize.translations.noResults+'<span></div>';
                        }
                    }
                }
            ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
                window.location.assign(suggestion.link);
            });
        }

        (function () {
            let sTrigger = $('.search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close'),
                $clear = sWrapper.find('.clear');
            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
                if(true === sWrapper.open)  {
                    sWrapper.find('input').focus();
                }
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });



            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });

            $clear.add($overlay).on('click', function (e) {
                e.preventDefault();
                sWrapper.find('.aa-input').val('');
                window.emiSearch.autocomplete('val', '');
                window.emiSearch.autocomplete('close');
            });


            $(document).keyup(function(e) {
                if (e.keyCode === 27) {
                    sWrapper.closer();
                }
            });
        })();




        (function () {
            $('.filter-control').on('change', function () {
                $(this).closest('form').submit();
            });
        })();


        // (function () {
        //     $('.select-links').on('change', function () {
        //         let link = $(this).find(':selected').data('href');
        //         if (link !== undefined) {
        //             window.location.href = link;
        //         }
        //     });
        // })(); 


        /* (function () {
            $('.filter-trigger').on('change', function () {
                $(this).closest('form').submit();
            });
        })(); */




        function setCookie(cname, cvalue, exdays) {
            let d = new Date(),
                expires;
            if (exdays) {
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                expires = "expires="+ d.toUTCString();
            } else {
                expires = "expires=0";
            }

            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [
            // {
            //     element: $('#f-img-controls'),
            //     property: 'width',
            //     callback: calculateImgWidth
            // }
        ];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }



        (function () {

            if (!isMobile){
                let $frame = $('.frame');

                if ($frame.length > 0) {

                    $frame.each(function () {

                        let $scrollBar = $(this).siblings('.slide_scroll_bar').find('.o-scrollbar');

                        dynamicElements.push(
                            {
                                'element': $(this),
                                'property': 'padding-left',
                                'callback': calcFluidPadding
                            }
                        );
                        $(this).css('padding-left', calcFluidPadding());

                        new Sly($(this), {
                            horizontal: 1,
                            itemNav: 'basic',
                            smart: 0,
                            mouseDragging: 1,
                            touchDragging: 1,
                            releaseSwing: 0,
                            speed: 300,
                            dragHandle: 1,
                            dynamicHandle: 1,
                            scrollBar: $scrollBar,
                            cycleBy: 'items'
                        }).init();
                    });

                }
            }

        })();

        $(window).on('resize load', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

             return ($( 'body' ).width() - $container.width()) / 2;
        }

        function calculateImgWidth() {
            let $container = $('.container');

            return ($( 'body' ).width() - $container.width()) / 2;

            return 20;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.offcanvas-collapse'),
                navbarObj: $('.navbar'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.items.navbarObj.toggleClass('menu-open');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.items.navbarObj.addClass('menu-open');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.items.navbarObj.removeClass('menu-open');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

        //Co-financed projects page datepicker initialization
        (function() {
            function hideDaysFromCalendar() {
                var thisCalendar = $(this);
                $('.ui-datepicker-calendar').detach();
                // Also fix the click event on the Done button.
                $('.ui-datepicker-close').unbind("click").click(function() {
                    var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
                    var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
                    thisCalendar.datepicker('setDate', new Date(year, month, 1));
                });
            }

            // Datepicker error fix

            $('#datepicker_start').datepicker({
                showButtonPanel: true,
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                closeText: "Izberi",
                prevText: "&#x3C;Prejšnji",
                nextText: "Naslednji&#x3E;",
                currentText: "Trenutni",
                monthNames: [ "Januar", "Februar", "Marec", "April", "Maj", "Junij",
                    "Julij", "Avgust", "September", "Oktober", "November", "December" ],
                monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Maj", "Jun",
                    "Jul", "Avg", "Sep", "Okt", "Nov", "Dec" ],
                dayNames: [ "Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota" ],
                dayNamesShort: [ "Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob" ],
                dayNamesMin: [ "Ne", "Po", "To", "Sr", "Če", "Pe", "So" ],
                weekHeader: "Teden",
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: ""
            }).focus(hideDaysFromCalendar);


            $('#datepicker_end').datepicker({
                showButtonPanel: true,
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                closeText: "Izberi",
                prevText: "&#x3C;Prejšnji",
                nextText: "Naslednji&#x3E;",
                currentText: "Trenutni",
                monthNames: [ "Januar", "Februar", "Marec", "April", "Maj", "Junij",
                    "Julij", "Avgust", "September", "Oktober", "November", "December" ],
                monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Maj", "Jun",
                    "Jul", "Avg", "Sep", "Okt", "Nov", "Dec" ],
                dayNames: [ "Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota" ],
                dayNamesShort: [ "Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob" ],
                dayNamesMin: [ "Ne", "Po", "To", "Sr", "Če", "Pe", "So" ],
                weekHeader: "Teden",
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: ""
            }).focus(hideDaysFromCalendar);


        })();

    });

})( jQuery );
